import * as React from 'react';
import PropTypes from 'prop-types';
import { createTheme, CssVarsProvider } from '@mui/material/styles';

import { inputsCustomizations } from '../Customizations/inputs';
import { dataDisplayCustomizations } from '../Customizations/dateDisplay';
import { feedbackCustomizations } from '../Customizations/feedback';
import { navigationCustomizations } from '../Customizations/navigation';
import { surfacesCustomizations } from '../Customizations/surfaces';
import { colorSchemes, typography, shadows, shape } from './themePrimitives';
import CssBaseline from "@mui/material/CssBaseline";

function AppTheme(props) {
  const { children, disableCustomTheme, themeComponents } = props;

  const theme = React.useMemo(() => {
    return disableCustomTheme
      ? {}
      : createTheme({
          cssVariables: {
            colorSchemeSelector: 'data-mui-color-scheme',
            cssVarPrefix: 'template',
          },
          colorSchemes,
          typography,
          shadows,
          shape,
          components: {
            ...inputsCustomizations,
            ...dataDisplayCustomizations,
            ...feedbackCustomizations,
            ...navigationCustomizations,
            ...surfacesCustomizations,
            ...themeComponents,
          },
        });
  }, [disableCustomTheme, themeComponents]);

  if (disableCustomTheme) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <CssVarsProvider 
      theme={theme} 
      disableTransitionOnChange
      defaultMode="light"
      modeStorageKey='theme'
    >
      <CssBaseline />
      {children}
    </CssVarsProvider>
  );
}

AppTheme.propTypes = {
  children: PropTypes.node,
  /**
   * This is for the docs site. You can ignore it or remove it.
   */
  disableCustomTheme: PropTypes.bool,
  themeComponents: PropTypes.object,
};

export default AppTheme;